import { defaultHttpClient } from '../../httpClient';
import type { GetCodiGoodsResponse } from './types';

export const getCodiGoods = async (goodsSno: number) => {
  return defaultHttpClient
    .request<GetCodiGoodsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/codi_goods/`,
    })
    .then(result => result.data);
};
